<template>
  <section class="relative pb-12 pt-8">
    <div class="container">
      <div class="text-center w-full max-w-[400px] mx-auto mb-12">
        <h4 class="text-2xl font-semibold mb-4">Weitere Unternehmen</h4>
        <p class="text-slate-400">Entdecke über 50.000+ Jobs in Deutschland von Top Unternehmen aus der IT-Branche</p>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        <div
          v-for="(company, index) in companies"
          :key="index"
          class="shadow dark:shadow-gray-700 bg-white dark:bg-slate-900 rounded-md w-full flex flex-col relative pt-10 px-5 pb-3"
        >
          <router-link
            :to="{ name: 'Company', params: { slug: company.slug }}"
            class="absolute left-5 -top-7 block bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 p-2 rounded-md"
          >
            <img class="flex-shrink-0 w-10 h-10 object-cover rounded-md" :src="company.logoUrl || placeholderLogo" alt="">
          </router-link>

          <router-link
            :to="{ name: 'Company', params: { slug: company.slug }}"
            class="text-lg font-semibold mb-4"
          >
            {{ company.name }}
          </router-link>

          <hr class="border-t border-slate-200 dark:border-gray-700 mt-auto mb-4" />

          <div class="flex items-center justify-between gap-3">
            <div class="flex items-center gap-1 text-slate-400 overflow-hidden" v-if="company?.address || company?.location?.name">
              <i class="uil uil-map-marker"></i>
              <span class="truncate">{{ company.address || company.location.name }}</span>
            </div>

            <div class="ml-auto font-semibold text-gradient text-nowrap">
              {{ company.jobCount ? company.jobCount : '0' }} {{ company.jobCount && company.jobCount === 1 ? 'Job' : 'Jobs' }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <img class="absolute w-[20vw] -right-12 -top-16 hidden 2xl:block" src="@/assets/images/company/fox.png" />
  </section>
</template>

<script>
import placeholderAvatar from '@/assets/images/job/placeholder/job8.png';

export default {
  props: {
    companies: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      placeholderLogo: placeholderAvatar,
    }
  },
};
</script>